import React, { useEffect, useState } from 'react'
import { useMutation, useQuery } from '@apollo/client'
import {
  DELETE_REPORT_RELATED,
  DUPLICATED_REPORTS,
  GET_ALL_REPORTS,
  GET_CURRENT_REPORT_AND_REPORTS_RELATED,
  GET_REPORTS_AVAILABLE,
} from '../../../../../../graphql/Catalog/Reports/reports'
import LayoutTable from '../../../../../Global/LayoutTable'
import { toastSweetAlert } from '../../../../../Helpers/ToastSweetAlert'
import moment from 'moment'
import { useLoading } from '../../../../../../LoadingOverlay/LoadingOverlayContext'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import ReportsChanel from '../ReportsChanel'
import ReportsSubCategory from '../ReportsSubCategory'

const ModalReportsDuplicated = ({
  reportId,
  refetchOrigin = () => {},
  group_id,
  group_category_id,
  group_category_sub_id,
  zone_id,
  colony_id,
}) => {
  const MySwal = withReactContent(Swal)

  // Hooks to save data
  const { showLoading, hideLoading } = useLoading()
  const [pagePagination, setPagePagination] = useState({
    searchQuery: null,
    limit: 10,
    offset: 0,
  })
  const [dataToTable, setDataToTable] = useState({
    data: [],
    totalCount: 0,
  })
  const [selectedIds, setSelectedIds] = useState([])
  const [reports, setReports] = useState({
    currentReport: {
      id: null,
      folio: null,
      isOriginal: null,
      isDuplicated: null,
    },
    reportsRelated: [],
  })

  // Queries and Mutations
  const {
    data: dataReport,
    loading: loadingReport,
    error: errorReport,
    refetch: refetchCurrentReportAndReportsRelated,
  } = useQuery(GET_CURRENT_REPORT_AND_REPORTS_RELATED, {
    variables: { reportId },
    fetchPolicy: 'no-cache',
  })

  const {
    data,
    loading,
    error,
    refetch: refetchReportsAvailable,
  } = useQuery(GET_REPORTS_AVAILABLE, {
    variables: {
      searchQuery: pagePagination.searchQuery,
      limit: pagePagination.limit,
      offset: pagePagination.offset,
      notIds: [reportId || 0],
      group_id,
      group_category_id,
      group_category_sub_id,
      zone_id,
      colony_id,
    },
    fetchPolicy: 'no-cache',
  })

  const [DuplicatedReports] = useMutation(DUPLICATED_REPORTS)
  const [DeleteReportRelated] = useMutation(DELETE_REPORT_RELATED)

  // UseEffect to save data
  useEffect(() => {
    if (!loading) {
      if (error) {
        toastSweetAlert({ mode: 'error', message: error.message })
        return
      }

      const list = data.getReportsAvailable.rows.map((item) => ({
        id: item.id,
        Check: (
          <input
            type="checkbox"
            checked={selectedIds.includes(item.id)}
            onChange={() => handleToggleSelect(item.id)}
          />
        ),
        'Tipo/Canal': (
          <>
            <ReportsChanel
              category_name={item?.ReportToGroupCategory?.name}
              img={item?.ReportToGroupCategory?.icon}
              channel_capture={item?.channel_capture}
              sub_category_name={item?.ReportToGroupCategorySub?.name}
              img_sub_category={item?.ReportToGroupCategorySub?.icon}
            />
          </>

          // <ReportsChanel
          //   category_name={item?.ReportToGroupCategory.name}
          //   img={item?.ReportToGroupCategory.icon}
          //   channel_capture={item?.channel_capture}
          // />
        ),
        Folio: item?.folio,
        'Fecha inicio': item.start_date
          ? `${moment(item.start_date).format('DD/MM/YYYY')}, ${moment(
              item.start_date
            ).format('LT')}`
          : 'N/A',
        start_date_only__omit: item.start_date
          ? moment(item.start_date).format('DD/MM/YYYY')
          : 'N/A',
        // Grupo: item?.ReportToGroup?.name,
        // Categoría: item?.ReportToGroupCategory?.name,
        // Subcategoría: (
        //   <ReportsSubCategory
        //     sub_category_name={item?.ReportToGroupCategorySub?.name}
        //     img={item?.ReportToGroupCategorySub?.icon}
        //   />
        // ),
        // Canal: item.channel_capture,
        acciones: (
          <button
            className="btn btn-migrates btn-sm mb-1"
            onClick={() => handleSelectReport([item.id])}
          >
            Seleccionar
          </button>
        ),
      }))
      setDataToTable({ data: list, totalCount: data.getReportsAvailable.count })
    }
  }, [loading, error, data, selectedIds])

  useEffect(() => {
    if (!loadingReport) {
      if (errorReport) {
        toastSweetAlert({ mode: 'error', message: errorReport.message })
        return
      }
      if (dataReport?.getCurrentReportAndReportsRelated) {
        setReports(dataReport.getCurrentReportAndReportsRelated)
      }
    }
  }, [dataReport, loadingReport, errorReport])

  // Functions
  const handleSelectReport = async (duplicatedReports) => {
    if (duplicatedReports.length === 0) {
      toastSweetAlert({
        mode: 'error',
        message: 'Selecciona al menos un reporte como duplicado',
      })
      return
    }

    const result = await MySwal.fire({
      showCloseButton: true,
      icon: 'warning',
      title: 'Confirmar',
      html: (
        <div className="message-container">
          ¿Estas seguro de confirmar{' '}
          {duplicatedReports.length > 1
            ? 'los reportes como duplicados'
            : 'el reporte como duplicado'}
          ?
        </div>
      ),
      allowOutsideClick: false,
      buttonsStyling: false,
      showDenyButton: true,
      confirmButtonText: 'Aceptar',
      denyButtonText: 'Cancelar',
      reverseButtons: true,
      customClass: {
        title: 'StandarModalTitle',
        htmlContainer: 'StandarModalHtmlContainer',
        confirmButton: 'btn btn-migrates',
        denyButton: 'btn btn-migrates-white',
        footer: 'btn StandarModalFooterLogOut',
      },
    })

    if (result.isConfirmed) {
      showLoading()
      try {
        await DuplicatedReports({ variables: { reportId, duplicatedReports } })
        await refetchReportsAvailable()
        await refetchCurrentReportAndReportsRelated()
        hideLoading()
        toastSweetAlert({
          mode: 'okToast',
          message: 'Reportes duplicados actualizados correctamente',
        })
        setSelectedIds([])
        refetchOrigin()
      } catch (error) {
        hideLoading()
        toastSweetAlert({ mode: 'error', message: error.message })
      }
    }
  }

  const handleToggleSelect = (id) => {
    setSelectedIds((prevSelectedIds) =>
      prevSelectedIds.includes(id)
        ? prevSelectedIds.filter((selectedId) => selectedId !== id)
        : [...prevSelectedIds, id]
    )
  }

  const handleDeleteReportRelated = async (id) => {
    const result = await MySwal.fire({
      showCloseButton: true,
      icon: 'warning',
      title: 'Confirmar',
      html: (
        <div className="message-container">
          ¿Estas seguro de eliminar el documento ID: {id} de la relacion?
        </div>
      ),
      allowOutsideClick: false,
      buttonsStyling: false,
      showDenyButton: true,
      confirmButtonText: 'Aceptar',
      denyButtonText: 'Cancelar',
      reverseButtons: true,
      customClass: {
        title: 'StandarModalTitle',
        htmlContainer: 'StandarModalHtmlContainer',
        confirmButton: 'btn btn-migrates',
        denyButton: 'btn btn-migrates-white',
        footer: 'btn StandarModalFooterLogOut',
      },
    })

    if (result.isConfirmed) {
      showLoading()
      try {
        const res = await DeleteReportRelated({
          variables: { reportId: parseInt(id) },
        })
        if (res) {
          await refetchReportsAvailable()
          await refetchCurrentReportAndReportsRelated()
          toastSweetAlert({
            mode: 'okToast',
            message: 'Relacion del reporte eliminado correctamente',
          })
        }
        hideLoading()
        refetchOrigin()
      } catch (error) {
        hideLoading()
        toastSweetAlert({ mode: 'error', message: error.message })
      }
    }
  }

  return (
    <div className="modal-reports-duplicated">
      <h5>
        Reporte folio {reports.currentReport.folio} - Documento{' '}
        {reports.currentReport.isOriginal
          ? 'original'
          : reports.currentReport.isDuplicated
          ? 'duplicado'
          : 'disponible'}
      </h5>
      <ul>
        {reports.reportsRelated.map((reportRelated, index) => {
          return (
            <li key={`reports-related-item${index}`}>
              ID: {reportRelated.id}, Folio: {reportRelated.folio} (
              {reportRelated.isOriginal
                ? 'Original'
                : reportRelated.isDuplicated
                ? 'Duplicado'
                : 'Disponible'}
              )
              {reportRelated.isDuplicated && (
                <i
                  role="button"
                  className="ml-2 fas fa-trash"
                  style={{ color: '#374151' }}
                  onClick={() => handleDeleteReportRelated(reportRelated.id)}
                ></i>
              )}
            </li>
          )
        })}
      </ul>
      <br />
      <h5>Elige los reportes duplicados</h5>
      <LayoutTable
        title="Lista de reportes"
        hideId
        hideActions
        hideAddNew
        data={dataToTable.data}
        requery={GET_ALL_REPORTS}
        exportImportButton={false}
        totalCount={dataToTable.totalCount}
        pagePagination={pagePagination}
        setPagePagination={setPagePagination}
        loadingData={loading}
        FilterBarPlaceholder="Buscar por folio"
        showAddNewButton={selectedIds.length > 0}
        handleAddNewButton={() => handleSelectReport(selectedIds)}
        handleAddNewButtonTxt="Confirmar duplicados"
      />
    </div>
  )
}

export default ModalReportsDuplicated
